// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application Management Styles
 * Now using unified components for consistent UI
 */

/* Application Management Container */
.application-management {
  padding: 20px;
  background: #f9fafb;
  min-height: 100vh;
}

/* Management Container */
.applications-management-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 30px;
}

/* Loading */
.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .application-management {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .application-management {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationManagement.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Application Management Styles\n * Now using unified components for consistent UI\n */\n\n/* Application Management Container */\n.application-management {\n  padding: 20px;\n  background: #f9fafb;\n  min-height: 100vh;\n}\n\n/* Management Container */\n.applications-management-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n/* Loading */\n.loading-overlay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .application-management {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .application-management {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
